"use client";

import type { FC } from "react";
import Link from "next/link";

import type {
  THeaderActions,
} from "@/ui/components/navigation/Header/Header.config";
import { IconButton } from "@/ui/components/primitives/IconButton";

type THeaderActionsProps = {
  primary?: THeaderActions["primary"];
};

export const HeaderActions: FC<THeaderActionsProps> = ({ primary }) => (
  <div className="HeaderActions">
    { primary ? (
      "href" in primary
        ? <Link {...primary} className="block"/>
        : <IconButton {...primary} size="lg" />
    ) : null }
  </div>
);
